var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organisation)?_c('v-alert',{staticClass:"pa-3 mt-5",attrs:{"color":"lightest"}},[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.link))]),_c('copy-button',{attrs:{"text":_vm.link}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }